export const diaryCategoryIds = {
  uncategorised: 'd52f508e-7137-49cb-aca3-95fd3d31cd73'
};
